const sexArr = ["女","男","保密"]

const fileFormat = ["视频", "音频", "文档", "图片", "压缩包"]

const linkData = [
    {
        id: 1,
        name: "首页",
        url: "/",                
        icon: "icon-home",
        image: ""
    },
    {
        id: 2,
        name: "招生简章",
        url: "/portal/about/page",                
        icon: "icon-id-card-o",
        image: "2024.png",
        image2: "R_2024.png"
    },
    {
        id: 3,
        name: "课程设置",
        url: "/portal/about/kecheng",                
        icon: "icon-image",
        image: "jianjie.png",
        image2: "R_jianjie.png"
    },
    {
        id: 4,
        name: "学生作品",
        url: "/portal/works/index",                
        icon: "icon-a-qianbi1",
        image: "work0.png",
        image2: "R_work0.png"
    },
    {
        id: 5,
        name: "历年成绩",
        url: "/portal/about/chengji",                
        icon: "icon-louceng",
        image: "rongyu.png",
        image2: "R_rongyu.png"
    },
    {
        id: 6,
        name: "拙一师资",
        url: "/portal/teacher/index",                
        icon: "icon-qu-users",
        image: "tuandui.png",
        image2: "R_tuandui.png"
    },
    {
        id: 7,
        name: "教学环境",
        url: "/portal/about/huanjing",                
        icon: "icon-jianzhuwu",
        image: "huanjing.png",
        image2: "R_huanjing.png"
    },
    {
        id: 8,
        name: "教学成果",
        url: "/portal/article/lists/id/13",                
        icon: "icon-shuben",
        image: "liuxue.png",
        image2: "R_liuxue.png"
    },
    {
        id: 9,
        name: "教学视频",
        url: "/portal/article/video",                
        icon: "icon-shipin",
        image: "shipin.png",
        image2: "R_shipin.png"
    },
    {
        id: 9,
        name: "在线咨询",
        url: "/portal/about/map",                
        icon: "icon-erji",
        image: "server.png",
        image2: "R_server.png"
    }
]

const srcList = [
    {
        title: "华南理工大学第一名状元—谭熙鹏",
        src: "http://zhuo1.ff916.com/public/images/lists/31d9c43ba2590e15d4bf5952b77bfb01.jpg"
    },
    {
        title: "吉林师范大学 - 乔冰心",
        src: "http://zhuo1.ff916.com/public/images/lists/527fac3c4ef4276ddc01b168dde7d8c3.jpg"
    },
    {
        title: "厦门理工大学——庞双慧",
        src: "http://zhuo1.ff916.com/public/images/lists/bce4e0a91b60e13d59e2d17c37808b4b.jpg"
    },
    {
        title: "大连艺术学院——陶池",
        src: "http://zhuo1.ff916.com/public/images/lists/42d1c2887ff06f4efca4adf139a860d4.jpg"
    },
    {
        title: "北华大学——万志良",
        src: "http://zhuo1.ff916.com/public/images/lists/b693965190117b82728290f039722b41.jpg"
    },
    {
        title: "吉林建筑大学——万志良",
        src: "http://zhuo1.ff916.com/public/images/lists/b693965190117b82728290f039722b41.jpg"
    },
    {
        title: "吉林建筑大学——王肖依",
        src: "http://zhuo1.ff916.com/public/images/lists/b697c471d751737a9e3eadea7dbd22d4.jpg"
    },
    {
        title: "大连艺术学院——王肖依",
        src: "http://zhuo1.ff916.com/public/images/lists/b2560ce19fa30ce93b32e91a553c7baa.jpg"
    },
    {
        title: "海南大学——张菲菲",
        src: "http://zhuo1.ff916.com/public/images/lists/49b5db1206479c2086309139c5a97eea.jpg"
    },
    {
        title: "北华大学——杨艺星",
        src: "http://zhuo1.ff916.com/public/images/lists/83b5df7ac24dc3fd1e381896770a67ad.jpg"
    },
    {
        title: "吉林建筑大学——杨帆",
        src: "http://zhuo1.ff916.com/public/images/lists/87c7a06328f141ac198c0bedd92f9607.jpg"
    },
    {
        title: "吉林师范大学——张士强",
        src: "http://zhuo1.ff916.com/public/images/lists/4fb286b71989c2905890589051e65194.jpg"
    },
    {
        title: "四川美术学院——张耀月",
        src: "http://zhuo1.ff916.com/public/images/lists/f584aedbcee08ede4dad95e5c392d266.jpg"
    },
    {
        title: "江西师范大学——张士强",
        src: "http://zhuo1.ff916.com/public/images/lists/965d3949fa52fc6e07ae0f3c98f6703a.jpg"
    },
    {
        title: "武汉纺织大学——张月",
        src: "http://zhuo1.ff916.com/public/images/lists/4f7d842aade65dc2f31a81eaa0db232c.jpg"
    },
    {
        title: "吉林师范大学 - 乔冰心",
        src: "http://zhuo1.ff916.com/public/images/lists/527fac3c4ef4276ddc01b168dde7d8c3.jpg"
    },
    {
        title: "武汉纺织大学——张亚洲",
        src: "http://zhuo1.ff916.com/public/images/lists/f7b0ef7774b7514c91059468d7bd2aec.jpg"
    },
    {
        title: "湖南商学院——庞双慧",
        src: "http://zhuo1.ff916.com/public/images/lists/d52800c671056da8faff7a2df35cadb3.jpg"
    },
    {
        title: "大连艺术学院——庞双慧",
        src: "http://zhuo1.ff916.com/public/images/lists/dddc9901f401a7fcfce4abb08b922304.jpg"
    },
    {
        title: "鲁迅美术学院——周阳阳",
        src: "http://zhuo1.ff916.com/public/images/lists/61a9fcba7d2521e7963f3ca74aaace34.jpg"
    }
]

export default {
    sexArr,
    fileFormat,
    linkData,
    srcList
}


// WEBPACK FOOTER //
// ./src/utils/Global.js